import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '#pplx/frontend/aether/components/Button/index.js';
import { Popover } from '#pplx/frontend/aether/components/Popover/index.js';
import { TextPrimitive } from '#pplx/frontend/aether/primitives/TextPrimitive/index.js';
import { unavailableComputerModelMessage } from '#pplx/frontend/apps/ask/search-models-menu/ComputerModelAvailabilityMessages.js';
import { useSearchModels } from '#pplx/frontend/ask-models/hooks/useSearchModels.js';
import { getModelIcon, SearchModel } from '#pplx/frontend/ask-models/types/search-modes.js';
import { useIsMobileStyle } from '#pplx/frontend/platform-components/useMobileStyle.js';
import { FormattedMessage, useIntl } from 'react-intl';
const handleToggleTipTriggerClick = (event) => {
    // Keep this application-specific toggle tip from activating parent composer controls.
    event.stopPropagation();
};
const handleSuppressedIconTooltipOpenChange = () => { };
export const ComputerModelChip = ({ model }) => {
    const { $t } = useIntl();
    const { getModelProvider, getPillLabel, getModelConfig, hasLoadedModelConfigFromServer } = useSearchModels({
        reason: 'computer-model-chip',
    });
    const isMobileStyle = useIsMobileStyle();
    const label = getPillLabel(model);
    if (!label) {
        return null;
    }
    const unavailable = hasLoadedModelConfigFromServer &&
        model !== SearchModel.ASI_OPENROUTER &&
        getModelConfig(model) == null;
    const chipLabel = unavailable ? $t(unavailableComputerModelMessage, { model: label }) : label;
    const provider = getModelProvider(model);
    const modelIcon = getModelIcon(model, provider);
    const toggleTipContent = (_jsxs("div", { className: "flex flex-col gap-0", children: [_jsx(TextPrimitive, { variant: "small", color: "default", children: _jsx(FormattedMessage, { defaultMessage: "The orchestrator model for this session is {label}.", id: "787a4a8498", description: "Toggle tip body explaining the orchestrator model for this session", values: { label } }) }), _jsx(TextPrimitive, { variant: "small", color: "light", children: unavailable
                    ? $t({
                        defaultMessage: 'This model is unavailable. Start a new session to choose another model.',
                        id: '80049a8cb4',
                        description: 'Recovery guidance for an unavailable model in a read-only Computer follow-up chip',
                    })
                    : $t({
                        defaultMessage: "This can't be changed for follow-ups.",
                        id: '36c202cd2d',
                        description: 'Tooltip subtitle explaining the orchestrator model chip is read-only in follow-up ask inputs',
                    }) })] }));
    const triggerElement = (_jsx(Button, { variant: "text", size: "small", onClick: handleToggleTipTriggerClick, ...(isMobileStyle
            ? {
                rounded: true,
                'aria-label': chipLabel,
                icon: modelIcon,
                // The toggle tip owns the explanatory copy instead of the icon tooltip.
                tooltipOpen: false,
                tooltipOnOpenChange: handleSuppressedIconTooltipOpenChange,
            }
            : { pill: true, leadingAccessory: modelIcon, children: chipLabel }) }));
    return (_jsx(Popover, { triggerElement: triggerElement, side: "top", children: toggleTipContent }));
};
//# sourceMappingURL=ComputerModelChip.js.map